// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__rpj7R","authInput":"Input_authInput__AyDM6","icon":"Input_icon__69Ng7","side":"Input_side__awQHj","up":"Input_up__BjokP"};